import React,{useState} from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiImage}=FiIcons;

const ImageWithFallback=({
  src,
  alt='',
  className='',
  fallbackLabel='Image unavailable',
  fallbackIcon=FiImage
})=>{
  const [hasError,setHasError]=useState(!src);

  if (hasError) {
    return (
      <div
        className={`${className} flex flex-col items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-slate-100 text-center`}
        role="img"
        aria-label={alt || fallbackLabel}
      >
        <SafeIcon
          icon={fallbackIcon}
          className="mb-3 text-4xl text-indigo-200"
        />
        <span className="px-4 text-[10px] font-black uppercase tracking-widest text-slate-400">
          {fallbackLabel}
        </span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={()=>setHasError(true)}
    />
  );
};

export default ImageWithFallback;